import React from "react";
import "./index.css";

export function HeaderMovil({ children }) {
	return <div className="container-movil-pdf-header">{children}</div>;
}
